module.exports = __webpack_public_path__ + "img/notification_handled.874467f3.png";